import React, { useEffect } from 'react';
import './lightbox.css';

const Lightbox = ({ images, index, onClose, onPrev, onNext }) => {
    useEffect(() => {
        const handleKey = (e) => {
            if (e.key === 'Escape') onClose();
            if (e.key === 'ArrowLeft') onPrev();
            if (e.key === 'ArrowRight') onNext();
        };
        document.addEventListener('keydown', handleKey);
        return () => document.removeEventListener('keydown', handleKey);
    }, [onClose, onPrev, onNext]);

    if (index < 0 || index >= images.length) return null;
    const { src, alt } = images[index];

    return (
        <div className="lightbox-overlay" onClick={onClose}>
            <div className="lightbox-content" onClick={e => e.stopPropagation()}>
                <button className="lightbox-close" onClick={onClose} aria-label="Close">&times;</button>
                <button className="lightbox-prev" onClick={onPrev} disabled={index === 0} aria-label="Anterior">&#8249;</button>
                <img className="lightbox-img" src={src} alt={alt || `imagen ${index + 1}`} />
                <button className="lightbox-next" onClick={onNext} disabled={index === images.length - 1} aria-label="Siguiente">&#8250;</button>
            </div>
        </div>
    );
};

export default Lightbox;
